import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-1 items-start" }
const _hoisted_2 = { class: "flex gap-x-2 items-center cursor-pointer group" }
const _hoisted_3 = ["value"]

import { ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxFilter',
  props: /*@__PURE__*/_mergeModels({
    options: {}
  }, {
    "modelValue": {
  },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["change"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel<FilterOption[] | null>(__props, "modelValue", {
  set(value) {
    if (value === null || value.length === 0) {
      return null;
    }
    return value;
  },
  get(value) {
    return value === null ? [] : value;
  }
})

const props = __props;

const emit = __emit;

const numItemsAboveFold = ref(4);
const isExpanded = ref(false);
const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

watch(model, (newValue) => {
  emit('change', newValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          value: option,
          class: _normalizeClass([{
          'group-hover:bg-neutral-200': !model.value.includes(option),
        }, "w-5 h-5 rounded-sm border-2 transition cursor-pointer focus:ring-0 focus:ring-transparent focus:ring-offset-0 text-teal border-neutral-300"])
        }, null, 10, _hoisted_3), [
          [_vModelCheckbox, model.value]
        ]),
        _createElementVNode("span", null, _toDisplayString(option.title), 1)
      ], 512)), [
        [_vShow, isExpanded.value || index < numItemsAboveFold.value]
      ])
    }), 256)),
    (_ctx.options.length > numItemsAboveFold.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _withModifiers(toggleExpanded, ["prevent"]),
          class: "text-sm underline text-teal"
        }, [
          _withDirectives(_createElementVNode("span", null, "Vis alle (" + _toDisplayString(_ctx.options.length - numItemsAboveFold.value) + ")", 513), [
            [_vShow, !isExpanded.value]
          ]),
          _withDirectives(_createElementVNode("span", null, "Vis færre", 512), [
            [_vShow, isExpanded.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})